import { DeviceInfo } from "~/types/deviceInfo";
import APIService from "./APIServices";
import { authenticationService } from "./authentication-service";

const deviceInfoAPI = new APIService<DeviceInfo>("deviceInfo");

export const deviceInfoService = {
  getSubscribersDeviceInfo: deviceInfoAPI.getAll,
  getTacSubscribersDeviceInfo,
  postSubscribersDeviceInfo,
  putSubscribersDeviceInfo,
  deleteSubscribersDeviceInfo,
  setTacDefaultProfile,
};

async function checkedDeviceInfoRequest<T>(path: string, method: string, body?: unknown): Promise<T> {
  const response = await fetch(`${deviceInfoAPI.url}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authenticationService.currentUserValue?.token}`,
    },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const text = await response.text();
  let payload: any;
  try {
    payload = text ? JSON.parse(text) : undefined;
  } catch {
    payload = undefined;
  }

  const result = payload?.data ?? payload;
  if (!response.ok) {
    throw result ?? { errors: [{ message: text || `Device Info request failed (${response.status})` }] };
  }
  return result as T;
}

function postSubscribersDeviceInfo(deviceInfo: DeviceInfo) {
  return checkedDeviceInfoRequest<DeviceInfo>("", "POST", deviceInfo);
}

function putSubscribersDeviceInfo(deviceInfo: DeviceInfo) {
  return checkedDeviceInfoRequest<DeviceInfo>(`/${deviceInfo.id}`, "PUT", deviceInfo);
}

function deleteSubscribersDeviceInfo(id: string) {
  return checkedDeviceInfoRequest<void>(`/${id}`, "DELETE");
}

function setTacDefaultProfile(id: string) {
  return checkedDeviceInfoRequest<DeviceInfo>(`/${id}/default`, "PUT", {});
}

async function getTacSubscribersDeviceInfo(tac: string) {
  try {
    const url = `tac/${tac}`;
    return await deviceInfoAPI.get(url);
  } catch (error) {
    console.log(error);
    throw error;
  }
}
